export default "<div id=\"breadcrumb-item\">{{breadCrumbText}}</div>\r\n\r\n";